'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import classNames from 'classnames';
import { JobDetail } from '~/types/job-detail';

interface JobInfoProps {
  job: JobDetail;
  isMobile: boolean;
}

export function JobInfo(props: JobInfoProps) {
  const { job, isMobile } = props;
  const [isCollapsed, setIsCollapsed] = useState(true);
  const annualArray = job.annual_salary ? job.annual_salary.split('万円') : [];

  return (
    <div className="p-job-info">
      <table className="p-job-info__table">
        <tbody>
          {job.annual_salary && (
            <tr className="p-job-info__tr">
              <th className="p-job-info__th u-pt11">
                <p
                  className={classNames(
                    'u-flex -items-center',
                    isMobile ? 'u-gap4' : 'u-gap6',
                  )}
                >
                  <Image
                    src="/nextjs/images/icons/ic_money.svg"
                    width={16}
                    height={16}
                    alt="給与アイコン"
                    className="u-mb2 p-job-info__icon"
                  />
                  <span className="p-job-info__text">年収</span>
                </p>
              </th>
              <td className="p-job-info__td u-pos-rel">
                <b className="p-job-info__text -lg-red">{annualArray[0]}</b>
                <b className="p-job-info__text">万円</b>
                {annualArray[1]}
                {!isMobile && (
                  <Link href="#salary" className="c-more-link">
                    詳しく見る
                  </Link>
                )}
              </td>
            </tr>
          )}
          {job.categories && job.categories.length > 0 && (
            <tr className="p-job-info__tr">
              <th className="p-job-info__th">
                <p
                  className={classNames(
                    'u-flex -items-center',
                    isMobile ? 'u-gap4' : 'u-gap6',
                  )}
                >
                  <Image
                    src="/nextjs/images/icons/ic_bag.svg"
                    width={16}
                    height={16}
                    alt="カバンアイコン"
                    className="u-mb2 p-job-info__icon"
                  />
                  <span className="p-job-info__text">職種</span>
                </p>
              </th>
              <td className="p-job-info__td u-pos-rel">
                {job.categories.map((category, i) => (
                  <span key={i}>
                    {i === 1 || i === 3 ? '/' : i === 2 ? <br /> : ''}
                    {category?.name}
                  </span>
                ))}
                {!isMobile && (
                  <Link href="#description" className="c-more-link">
                    詳しく見る
                  </Link>
                )}
              </td>
            </tr>
          )}
          {job.prefecture && (
            <tr className="p-job-info__tr">
              <th className="p-job-info__th">
                <p
                  className={classNames(
                    'u-flex -items-center',
                    isMobile ? 'u-gap4' : 'u-gap6',
                  )}
                >
                  <Image
                    src="/nextjs/images/icons/ic_location.svg"
                    width={16}
                    height={16}
                    alt="マップアイコン"
                    className="u-mb2 p-job-info__icon"
                  />
                  <span className="p-job-info__text">勤務地</span>
                </p>
              </th>
              <td className="p-job-info__td u-pos-rel">
                {job.prefecture?.name}
                {!isMobile && (
                  <Link href="#work_location" className="c-more-link">
                    詳しく見る
                  </Link>
                )}
              </td>
            </tr>
          )}
          {(job.license_detail || job.optional_license_detail) && (
            <tr className="p-job-info__tr">
              <th className="p-job-info__th">
                <p
                  className={classNames(
                    'u-flex -items-center',
                    isMobile ? 'u-gap4' : 'u-gap6',
                  )}
                >
                  <Image
                    src="/nextjs/images/icons/ic_license.svg"
                    width={16}
                    height={16}
                    alt="資格アイコン"
                    className="u-mb2 p-job-info__icon"
                  />
                  <span className="p-job-info__text">資格</span>
                </p>
              </th>
              <td className="p-job-info__td u-pos-rel">
                {job.license_detail &&
                job.license_detail.split('\n').length >= 5 ? (
                  <div id="js-collapsed" className="p-collapsed">
                    {isCollapsed
                      ? job.license_detail
                          .split('\n')
                          .slice(0, 4)
                          .map((line, i) => (
                            <span key={i}>
                              {line}
                              <br />
                            </span>
                          ))
                      : job.license_detail.split('\n').map((line, i) => (
                          <span key={i}>
                            {line}
                            <br />
                          </span>
                        ))}
                    <button onClick={() => setIsCollapsed(!isCollapsed)}>
                      {isCollapsed ? 'もっと見る' : '閉じる'}
                    </button>
                  </div>
                ) : (
                  job.license_detail &&
                  job.license_detail.split('\n').map((line, i) => (
                    <span key={i}>
                      {line}
                      <br />
                    </span>
                  ))
                )}
                {job.license_detail?.trim() === '' &&
                  job.optional_license_detail && (
                    <>
                      優遇資格
                      <br />
                      {job.optional_license_detail
                        .split('\n')
                        .map((line, i) => (
                          <span key={i}>
                            {line}
                            <br />
                          </span>
                        ))}
                    </>
                  )}
                {!isMobile && (
                  <Link href="#requirements" className="c-more-link">
                    詳しく見る
                  </Link>
                )}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
